import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  return <section className="py-16 px-4 md:py-24 bg-[#FDFBF7]" data-id="element-67">
      <div className="max-w-5xl mx-auto" data-id="element-68">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-69">
          Para quién es (y para quién no)
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-70">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#2F855A]" data-id="element-71">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-72">
              <CheckCircle2 className="w-8 h-8 text-[#2F855A] mr-3" data-id="element-73" />
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-74">
              {['quieres comer mexicano sin vivir con miedo', 'te urge un plan diario simple', 'estás cansado de improvisar'].map((item, i) => <li key={i} className="flex items-start text-gray-700 text-lg" data-id="element-75">
                  <span className="w-2 h-2 bg-[#2F855A] rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-76"></span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-gray-400" data-id="element-77">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-78">
              <XCircle className="w-8 h-8 text-gray-400 mr-3" data-id="element-79" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-80">
              {['buscas curas o promesas médicas', 'quieres un plan clínico personalizado (esto es educativo)', 'no estás dispuesto a aplicar 1 palanca por comida'].map((item, i) => <li key={i} className="flex items-start text-gray-700 text-lg" data-id="element-81">
                  <span className="w-2 h-2 bg-gray-400 rounded-full mt-2.5 mr-3 flex-shrink-0" data-id="element-82"></span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}